<label>{{ label }}</label>
<mat-form-field *ngIf="formControl">
  <mat-select
    #selectEl
    [formControl]="formControl"
    (selectionChange)="onChange($event)"
    [disabled]="disabled"
    [id]="id"
    aria-haspopup="listbox"
  >
    <mat-option
      *ngFor="let option of options"
      [value]="option[optionValueField]"
    >
      {{ option[optionTextField] }}
    </mat-option>
  </mat-select>
</mat-form-field>
